import { useQuery } from "react-query";
import { fetchCities, ValidCity } from "./fetchCities";

export const useGetCities = (params: Parameters<typeof fetchCities>[0] & {
  useShowOnSearchFilter?: boolean
}) => {
  return useQuery<ValidCity[]>(["cities", params.language], () => fetchCities(params));
};
